import { AxiosInstance } from "axios";
import dataProviderToApiMap from "../../../common/data/dataProviderToApiMap";
import { IPagedResultDto } from "../../../common/data/types";

export type DataTransferCategoryKey =
  | "drivers"
  | "vehicles"
  | "trailers"
  | "locations";
export type DataTransferMode = "export" | "import";

export interface DataTransferHistoryRequest {
  page: number;
  perPage: number;
  search?: string;
  status?: string;
  sortField?: string;
  sortOrder?: "ASC" | "DESC";
  searchFields?: string[];
}

const buildHistoryRequest = ({
  page,
  perPage,
  search,
  status,
  sortField,
  sortOrder,
  searchFields,
}: DataTransferHistoryRequest) =>
  dataProviderToApiMap.mapGetListParams(
    {
      pagination: {
        page,
        perPage,
      },
      sort: {
        field: sortField ?? "creationTime",
        order: sortOrder ?? "DESC",
      },
      filter: {
        ...(search ? { q: search } : {}),
        ...(status ? { status } : {}),
      },
    },
    searchFields ?? [
      "description",
      "fileName",
      "creatorName",
      "creatorSurname",
      "creatorEmail",
    ]
  );

export const getDataTransferHistory = async (
  axios: AxiosInstance,
  category: DataTransferCategoryKey,
  mode: DataTransferMode,
  request: DataTransferHistoryRequest
): Promise<IPagedResultDto<any>> => {
  const response = await axios.post(
    `/api/app/data-transfer/${category}/${mode}/get-filtered-list`,
    buildHistoryRequest(request)
  );

  return response.data ?? {};
};

export const createDataTransferExport = async (
  axios: AxiosInstance,
  category: DataTransferCategoryKey,
  payload: Record<string, unknown>
) => {
  const response = await axios.post(
    `/api/app/data-transfer/${category}/export`,
    payload
  );

  return response.data;
};

export const uploadDataTransferImportFile = async (
  axios: AxiosInstance,
  category: DataTransferCategoryKey,
  file: File
) => {
  const formData = new FormData();
  formData.append("input", file);

  const response = await axios.post(
    `/api/app/data-transfer/${category}/import/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

export const createDataTransferImport = async (
  axios: AxiosInstance,
  category: DataTransferCategoryKey,
  payload: Record<string, unknown>
) => {
  const response = await axios.post(
    `/api/app/data-transfer/${category}/import`,
    payload
  );

  return response.data;
};

export const getDataTransferJob = async (
  axios: AxiosInstance,
  category: DataTransferCategoryKey,
  mode: DataTransferMode,
  id: string
) => {
  const response = await axios.get(
    `/api/app/data-transfer/${category}/${mode}/${id}`
  );

  return response.data;
};
